import { Component } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { NewSubscriberMailService } from './new-subscriber-mail.service';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
// import { DatePicker } from 'primeng/datepicker';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ToastMessageService } from 'src/app/toastr.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-new-subscriber-mail',
  templateUrl: './new-subscriber-mail.component.html',
  styleUrl: './new-subscriber-mail.component.scss'
})
export class NewSubscriberMailComponent {
  email: any;
  subscriberMail: any;
  date: Date | undefined;
  SelectedDate: any;
  approvedANDAHeaders: string[] = [];
  approvedANDAData: any[] = [];
  tentativeANDAHeaders: string[] = [];
  tentativeANDAData: any[] = [];
  counts: Array<{ type: string; count: number }> = [];
  approvedANDASummary: any;
  tentativeANDASummary: any;
  currentDate: any;
  editStates: boolean[] = [];
  saveMailData: any;
  public Editor = ClassicEditor;
  public Editotentativer = ClassicEditor;

  public editorData = '<p>Type your content here...</p>';
  isEditing: boolean = false;
  isDialogVisible: boolean = false;

  editors: any[] = [];
  editorstentativer: any[] = [];
  

  constructor(public toastr: ToastrService, private NewSubscriberMailService: NewSubscriberMailService, private sanitized: DomSanitizer) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
  }

  onDateChange(event: any) {
    this.SelectedDate = this.date.toLocaleDateString("es-CL");
    console.log(this.SelectedDate);
    const userEmail = this.email;
    this.NewSubscriberMailService.getSubscriberMailData(this.email, this.SelectedDate).subscribe(response => {
      this.subscriberMail = response;
      console.log("knfejrnjrs", this.subscriberMail)

      if (response.current_date) {
        this.currentDate = response.current_date;
      }

      this.counts = [
        { type: "Approved ANDA", count: response.approved_anda_count },
        { type: "Tentative ANDA", count: response.tentative_approved_anda_count }
      ];

      // Process Approved ANDA Summary
      if (response.approved_total_summary?.length > 0) {
        this.approvedANDASummary = response.approved_total_summary;
      }

      // Process Tentative ANDA Summary
      if (response.tentative_total_summary?.length > 0) {
        this.tentativeANDASummary = response.tentative_total_summary;
      }
      // Process ApprovedANDAPhase2 data
      if (response.approved_phase2_data?.length > 0) {
        this.approvedANDAHeaders = Object.keys(response.approved_phase2_data[0]); // Extract headers
        this.approvedANDAData = response.approved_phase2_data; // Extract data
      }

      if (response.tentative_phase2_data?.length > 0) {
        this.tentativeANDAHeaders = Object.keys(response.tentative_phase2_data[0]); // Extract headers
        this.tentativeANDAData = response.tentative_phase2_data; // Extract data
      }
    });

  }

  // toggleEditMode() {
  //   if (this.isEditing) {
  //     // Preparing payload

  //     const date = this.SelectedDate;
  //     const email_context = {
  //       "approved_anda_count": this.counts.find(item => item.type === 'Approved ANDA')?.count || 0,
  //       "tentative_approved_anda_count": this.counts.find(item => item.type === 'Tentative ANDA')?.count || 0,
  //       "approved_phase2_data": this.approvedANDAData,
  //       "tentative_phase2_data": this.tentativeANDAData,
  //       "approved_total_summary": this.approvedANDASummary,
  //       "tentative_total_summary": this.tentativeANDASummary,
  //       "current_date": this.SelectedDate,
  //     };

  //     // Call the API to save data
  //     this.saveEditedDataToServer({ date, email_context });
  //   }

  //   // Toggle editing mode
  //   this.isEditing = !this.isEditing;
  // }

  toggleEditMode() {
    if (this.isEditing) {

      const arraySave = this.getEditorsContent()
      const arraySaveTativer = this.getEditorReadytativer()

      const data = {
        date: this.SelectedDate,
        email_context: {
          "approved_anda_count": this.counts.find(item => item.type === 'Approved ANDA')?.count || 0,
          "tentative_approved_anda_count": this.counts.find(item => item.type === 'Tentative ANDA')?.count || 0,
          "approved_phase2_data": this.approvedANDAData,
          "tentative_phase2_data": this.tentativeANDAData,
          "approved_total_summary": arraySave || [],  // || this.approvedANDASummary
          "tentative_total_summary": arraySaveTativer || [], //|| this.tentativeANDASummary
          "current_date": this.SelectedDate,
        }
      };
      this.approvedANDASummary = arraySave;
      this.tentativeANDASummary = arraySaveTativer;

      console.log('Saving data:', data);
      // Call the save API with the prepared payload
      this.NewSubscriberMailService.EditSubscriberMailData(data).subscribe(
        response => console.log('Data saved successfully', response),
        error => console.error('Error saving data', error)
      );
    }
    this.isEditing = !this.isEditing; // Toggle edit mode
  }

  onEditorChange(event: any, index: number) {
    // This method is triggered whenever content changes in the CKEditor
    console.log('Updated summary at index ' + index, event);

    // Update the approvedANDASummary array directly if needed
    this.approvedANDASummary[index] = event;
  }
  getEditorsContent() {
    return this.editors.map((editor, index) => {
      return editor ? editor.getData() : '';
    });
  }
  getEditorReadytativer() {
    return this.editorstentativer.map((editor, index) => {
      return editor ? editor.getData() : '';
    });
  }
  onEditorReady(editorInstance: any, index: number) {
    this.editors[index] = editorInstance;
    editorInstance.ui.view.editable.element.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
          document.querySelectorAll('.ck-content p').forEach((p:any) => {
              p.style.marginBottom = "0"; // Adjust as needed
          });
      }
  });
  }

  onEditorReadytativer(editorInstance: any, index: number) {
    this.editorstentativer[index] = editorInstance;
    editorInstance.ui.view.editable.element.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
          document.querySelectorAll('.ck-content p').forEach((p:any) => {
              p.style.marginBottom = "0"; // Adjust as needed
          });
      }
    });
  }

  // saveEditedDataToServer(payload: any) {
  //   console.log('Saving edited data:', payload);

  //   this.NewSubscriberMailService.EditSubscriberMailData(payload).subscribe(
  //     response => {
  //       console.log('Data saved successfully', response);
  //       this.subscriberMail = response['email_template_data'];
  //       this.toastr.success('Data saved successfully!');
  //     },
  //     error => {
  //       console.error('Error saving data', error);
  //       this.toastr.error('Error saving data. Please try again!');
  //     }
  //   );
  // }

  sanitizeHtml(content: string): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(content);
  }

  addRow(dataArray: any[], headers: string[], existingRow?: any) {
    const newRow = existingRow
      ? { ...existingRow } // Clone the existing row
      : headers.reduce((acc, header) => {
        acc[header] = '';
        return acc;
      }, {});
    dataArray.push(newRow);
  }

  // addRow(dataArray: any[], headers: string[]) {
  //   const newRow = headers.reduce((acc, header) => {
  //     acc[header] = '';
  //     return acc;
  //   }, {});
  //   dataArray.push(newRow);
  // }

  deleteRow(dataArray: any[], index: number) {
    dataArray.splice(index, 1);
  }

  ViewMailTemplate() {
    this.NewSubscriberMailService.getViewTemplate(this.SelectedDate).subscribe(
      response => {
        console.log('Data viewed successfully', response);
        this.subscriberMail = response['email_template'];
        // this.toastr.success('Data viewed successfully!');
        this.isDialogVisible = true; // Open the dialog
      },
      error => {
        console.error('Error viewing data', error);
        this.toastr.error('Error viewing data. Please try again!');
      }
    );
  }

  SendMailTemplate() {
    // Prepare the payload for the API call
    const payload = {
      email_template: this.subscriberMail, // Use the email template from the response
      date: this.SelectedDate // Include the current date
    };

    this.NewSubscriberMailService.SaveSubscriberMailData(payload).subscribe(
      response => {
        console.log('Mail sent successfully', response);
        this.toastr.success('Mail sent successfully!');
        this.isDialogVisible = false; // Close the dialog after sending the email
      },
      error => {
        console.error('Error sending mail', error);
        this.toastr.error('Error sending mail. Please try again!');
      }
    );
  }

  addNewTentativeSummary() {
    // Add a new CKEditor instance with an empty summary
    this.tentativeANDASummary.push('');
  }

  addNewApprovedSummary() {
    // Add a new CKEditor instance with an empty summary
    this.approvedANDASummary.push('');
  }
  deleteRowArroved(summary,i){
    this.approvedANDASummary.splice(i, 1);
    this.editors.splice(i, 1);
  }
  tentativeRowArroved(summary,i){
    this.tentativeANDASummary.splice(i, 1);
    this.editorstentativer.splice(i, 1);
  }

  // duplicateRow(dataArray: any[], index: number): void {
  //   const rowToDuplicate = { ...this.approvedANDAData[index] }; // Clone the row
  //   this.approvedANDAData.splice(index + 1, 0, rowToDuplicate); // Insert the duplicate row after the current one
  // }

  // saveEditedDataToServer(payload: any) {
  //   // console.log('Saving edited data:', payload);
  //   this.NewSubscriberMailService.EditSubscriberMailData(payload).subscribe(response => {
  //     console.log('Data saved successfully', response);
  //     this.subscriberMail = response['email_template_data']
  //     this.toastr.success('Data saved successfully!');
  //   },
  //     (error) => {
  //       console.error('Error saving data', error);
  //       this.toastr.error('Error saving data. Please try again!');
  //     });
  // }

}
